import { useEffect } from "react"
import { SetterOrUpdater, useRecoilState } from "recoil"
import { DataGridFilterState } from "state/DataGridFilterState"
import { TDataGridSortFilter } from "./useDataGridFilterState"

export const useDataGridFilterGlobalState = (id: string, defaultValue?: TDataGridSortFilter) => {

    const [value, setValue] = useRecoilState(DataGridFilterState(id))

    useEffect(() => {
        defaultValue && setValue(defaultValue)
    }, [])

    const setFilterValue = (key: string | SetterOrUpdater<TDataGridSortFilter>, value?: any) => {
        if (typeof key === 'string') {
            return setValue((v: TDataGridSortFilter) => ({ ...v, [key]: value }))
        }
        setValue(key)
    }

    return {
        value,
        setValue: setFilterValue
    }
}
